<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Account Ledger" :breadcrumb="breadcrumb"/>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <template v-if="!$store.getters.isSubMerchant">
          <div class=" row m-1">
            <div class="col-md-6 col-sm-12" >
              <label>Select Store</label>
              <InfiniteSelect
                  api-url="v1/get-stores"
                  ref="storeSelect"
                  :request-params="requestParams"
                  :formatter="(obj) => obj?.name || ''"
                  :response-parser="(response) => response?.response?.data?.data?.stores?.data || []"
                  :pagination-parser="parseChannelPagination"
                  key-field="id"
                  @selectedFullObj="(item) => selectedStore = item.id"
                  placeholder-text="Select a store..."
              />
            </div>
<!--            <div class="col-md-6 col-sm-12" >-->
<!--              <label>Select Channel</label>-->
<!--              <InfiniteSelect-->
<!--                  api-url="v1/get-stores"-->
<!--                  ref="channelSelect"-->
<!--                  :request-params="requestParams"-->
<!--                  :formatter="resolveChannelName"-->
<!--                  :response-parser="(response) => response?.response?.data?.data?.channels?.data || []"-->
<!--                  :pagination-parser="parseChannelPagination"-->
<!--                  key-field="id"-->
<!--                  @selectedFullObj="(item) => selectedChannel = item.id"-->
<!--                  placeholder-text="Select a channel..."-->
<!--              />-->
<!--            </div>-->
          </div>
          <div class=" row m-1">
            <div class="col-md-4 col-sm-12 ">
              <label>Start Date</label>
              <datepicker :upperLimit="upperLimitDate" v-model="fromDate" class="form-control"/>
            </div>
            <div class="col-md-4 col-sm-12 ">
              <label>End Date</label>
              <datepicker :upperLimit="upperLimitDate" v-model="toDate" class="form-control"/>
            </div>
          </div>
          <div class=" d-flex justify-content-end m-1 mr-2">
            <button type="button" class="btn-primary btn btn-sm" @click="onSubmitFilters">Search</button>
            <button type="button" class="btn-warning btn btn-sm ml-1" @click="clear">Clear</button>
            <button  type="button" class="btn-sm btn btn-gradient-success ml-1" @click="exportExcel">
              <BIconFileEarmarkExcelFill width="15" height="15"/>
              Export Excel
            </button>
          </div>
          </template>
          <LedgerLoadMoreTable v-if="accountId" :key="accountId"
              url="v1/get-account-ledger"
             :filteredData="filteredData"
             :tableHeaderValues="visibleTableHeaderValues"
             :actions="[]"
             :deleteActions="[]"
             :mutedData="[]"
             storageKey="merchant_ledger"
             :externalTotalRecord="[]"
              @perPageFilterChanged="perPageFilterChanged"
              :loadMore="true"
             :alterResponseData="alter"
             :showPerPage="true"

          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

import {mapState} from "vuex";
import {ref} from "vue";
import Datepicker from 'vue3-datepicker'
import LedgerLoadMoreTable from "@/pages/dashboard/account-ledger/LedgerLoadMoreTable";
import ToastificationContent from "@/components/common/ToastificationContent";
import SearchSelect from "@/components/common/SearchSelect.vue";
import InfiniteSelect from "@/components/common/InfiniteSelect.vue";

export default {
  components:{
    InfiniteSelect,
    SearchSelect,
    Datepicker,
    LedgerLoadMoreTable,
    ToastificationContent
  },
  computed: {
    ...mapState(['walletAccount']),
    visibleTableHeaderValues() {
      if (this.$store.getters.isSubMerchant) {
        return this.tableHeaderValues.filter(header => header.valueKey !== 'closing_balance')
      }
      return this.tableHeaderValues
    }
  },
  mounted() {
    if (this.walletAccount) {
      this.selectdValet = this.walletAccount
      if(this.selectdValet){
        this.accountId = this.selectdValet.id
        this.filteredData = {userAccountId : this.accountId }

      }
    }
  },
  data() {
    return {
      selectedStore: null,
      alter:{
        alter: (value) => {
          if(value){
            if(value.data){
              let temp = []
              value.data.forEach((eachArrayItem,index)=>{

                if(typeof(value.fullResponse.closingBalance) != 'undefined' && index == 0 && value.pagination.currentPage == 1){
                    this.orignalGivenClosingBalance = value.fullResponse.closingBalance
                    this.lastClosingBalance = this.orignalGivenClosingBalance

                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }

                }else{
                  eachArrayItem.closing_balance = this.lastClosingBalance

                  if(parseFloat(eachArrayItem.credit_amount) != parseFloat(0)){
                    //credit
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) -  parseFloat(eachArrayItem.credit_amount)

                  }else{
                    this.lastClosingBalance = parseFloat(this.lastClosingBalance) +  parseFloat(eachArrayItem.debit_amount)
                  }


                }


                temp.push(eachArrayItem)
              })
              value.data = temp
            }
          }

          return value
        }
      },
      orignalGivenClosingBalance:0,
      lastClosingBalance:0,
      channelList:[],
      selectedChannel: null,
      accountId: null,
      selectdValet: null,
      filteredData:{userAccountId : this.accountId },
      valetData: [],
      toDate: null,
      fromDate: null,
      breadcrumb: [
        {name: 'App'},
        {name: 'Account Ledger'},
      ],
      tableHeaderValues: [
        {
          title: 'Transaction ID',
          valueKey: 'transaction.uuid',
          html: true,
          alter:  (value,row)=> {
            var html = ''
            if (value)
            {
              html = `<span class="text-primary" style="cursor: pointer" title="Click For Details">${value}</span>`
            }


            if (row.transaction_type_id == 13 || row.transaction_type_id == 14) {
              if(row.transaction.reference_id){
                html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary ">${value}</span>
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.3rem">${row.transaction.reference_id}</div></p></div>`
              }
            }


            return html




          },
          cta: (row) => {
            this.$router.push({name: 'transactions-details-with-id',params: {id:row.transaction.uuid}})
          }
        },
        {
          title: 'Debit Amount',
          valueKey: 'debit_amount',
          html: true,
          alter: (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            }

            return html

          }
        },
        {
          title: 'Credit Amount',
          valueKey: 'credit_amount',
          html: true,
          alter: (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-success">${parseFloat(value / 100).toFixed(this.amountDecimalPlaces)}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            }
            return html

          }
        },
        {
          title: 'Closing Balance',
          valueKey: 'closing_balance',
          alter: (value) => {
            return parseFloat(value/100).toFixed(this.amountDecimalPlaces)
          }
        },
        {
          title: 'Channel',
          valueKey: 'transaction.channel',
          html: true,
          alter: function (value) {
            var html = '-'
            if(value)
            html = ` <a href="javascript:void()" class="badge badge-glow badge-light-primary">${value.name}</a>`

            return html


          }
        },
        {
          title: 'Currency',
          valueKey: 'transaction.currency.code',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-light-success">${value}</a>`

            return html


          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <span class="badge light badge-light-primary">
														${value}
													</span>`

            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<br> <span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: 'created_at',
       alter: (value) => {
            // return this.customFormatDateTime(value)
         return new Date(value).toISOString().slice(0, 16).replace('T', ' ')
          }
        },
      ],
      actions: [],
      requestParams: {
        paginate:1
      }
    }
  },
  methods: {
    resolveChannelName(obj){
      let name = ''
      if(obj.store){
        name+= obj.store.name+'/'
      }
      if(obj.terminal){
        name+= obj.terminal.name+'/'
      }

      name+= obj.name

      return name

    },
    parseChannelPagination(response) {
      let res = response?.response?.data?.data
      return {
        total: res?.channels?.paginationData?.total || 0,
        perPage: res?.channels?.paginationData?.perPage || 10
      };
    },
    exportExcel(){

      if(!this.toDate || !this.fromDate){
        this.toastG({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'BellIcon',
            text: 'Date Filters Are Required To Generate Excel',
            variant: 'danger',
          },
        })


        return
      }


      let requestData = {
        exportAs: 'excel',
        reportType: 'transaction_ledger',
        userAccountId : this.accountId
      }

      if(this.toDate){
        requestData.toDate =  this.formatDate(this.toDate)
      }
      if(this.fromDate){
        requestData.fromDate =   this.formatDate(this.fromDate)
      }

      if(this.selectedChannel){
        requestData.channelId = this.selectedChannel
      }



      this.downloadReport(requestData)
    },
    onSubmitFilters() {
      this.lastClosingBalance = this.orignalGivenClosingBalance
      let dataFiltered = {userAccountId : this.accountId }

      if(this.selectedChannel){
        dataFiltered.channelId = this.selectedChannel
      }

      if (this.selectedStore){
        dataFiltered.storeId = this.selectedStore
      }


      if(this.toDate){
        dataFiltered.toDate = this.formatDate(this.toDate)
      }
      if(this.fromDate){
        dataFiltered.fromDate = this.formatDate(this.fromDate)
      }



      this.filteredData = dataFiltered

    },
    clear(){
      this.filteredData = {userAccountId : this.accountId }
      this.selectedChannel = null
      this.selectedStore = null
      this.toDate = null
      this.fromDate = null
      this.$refs.storeSelect.clearSearch()
      this.$refs.channelSelect.clearSearch()
    },
    formatDate(val){
      let date = new Date(val)
      let day = ("0" + date.getDate()).slice(-2)
      let month = ("0" + (date.getMonth() + 1)).slice(-2)
      let year= date.getFullYear()

      let formatted_date = year+'-'+month+'-'+day
      return formatted_date
    },
    perPageFilterChanged(){
      this.lastClosingBalance = this.orignalGivenClosingBalance
    },

  },
  watch: {

    walletAccount(val) {
      this.lastClosingBalance = this.orignalGivenClosingBalance
      this.selectdValet = val

      let tempFilter = this.filteredData

      if(this.selectdValet){
        this.accountId = this.selectdValet.id
        tempFilter.userAccountId = parseInt(this.accountId)
      }else{
        if(typeof(tempFilter['userAccountId']) != 'undefined'){
          delete tempFilter['userAccountId']
        }
      }

      this.filteredData = JSON.parse(JSON.stringify(tempFilter))



    },
    // selectedChannel(val){
    //   this.lastClosingBalance = this.orignalGivenClosingBalance
    //   let tempFilter = this.filteredData
    //
    //   if(val){
    //     tempFilter.channelId =  val.id
    //   }else{
    //     if(typeof(tempFilter['channelId']) != 'undefined'){
    //       delete tempFilter['channelId']
    //     }
    //   }
    //
    //   this.filteredData = JSON.parse(JSON.stringify(tempFilter))
    //
    //
    //
    //
    // },
    // toDate(val){
    //   this.lastClosingBalance = this.orignalGivenClosingBalance
    //   let tempFilter = this.filteredData
    //   if(val){
    //     tempFilter.toDate = this.formatDate(val)
    //   }else{
    //     if(typeof(tempFilter['toDate']) != 'undefined'){
    //       delete tempFilter['toDate']
    //     }
    //   }
    //
    //   this.filteredData = JSON.parse(JSON.stringify(tempFilter))
    //
    // },
    // fromDate(val){
    //   this.lastClosingBalance = this.orignalGivenClosingBalance
    //   let tempFilter = this.filteredData
    //   if(val){
    //     tempFilter.fromDate = this.formatDate(val)
    //   }else{
    //     if(typeof(tempFilter['fromDate']) != 'undefined'){
    //       delete tempFilter['fromDate']
    //     }
    //   }
    //   this.filteredData = JSON.parse(JSON.stringify(tempFilter))
    //
    //
    // }
  }
}
</script>

